import api from '../utils/baseUrl';

class PlotsService {
    async get_statistics(granularity: 'day' | 'month' = 'month') {
        return await api.get('/api/dashboard', {
            params: { granularity }
        });
    }
}

export default new PlotsService();